export enum DistanceUnit {
    MILES = "M",
    KILOMETERS = "K",
    NAUTICAL_MILES = "N"
};

export interface Coordinate {
    Latitude: number;
    Longitude: number;
};